module.exports = __webpack_public_path__ + "static/img/train-phone.bb68dfc9.png";